import { z } from "zod";

import { UserEntity } from "~/entities/user/@x/auth";
import type { OperationalErrorOptions } from "~/shared/error";
import { OperationalError } from "~/shared/error";

const zIn = UserEntity.zSchema
  .pick({
    id: true,
  })
  .extend({
    currentPassword: UserEntity.zSchema.shape.password,
    newPassword: UserEntity.zSchema.shape.password,
  });
type In = z.infer<typeof zIn>;

const zErrorReason = z.enum(["CURRENT_PASSWORD_IS_INCORRECT"]);
const ErrorReason = zErrorReason.Enum;
type ErrorReason = z.infer<typeof zErrorReason>;

class Error extends OperationalError {
  readonly reason: ErrorReason;

  constructor(reason: ErrorReason, options?: OperationalErrorOptions) {
    super(options);
    this.reason = reason;
    this.message = `Failed to assign roles to user.`;
  }
}

export { Error, ErrorReason, zErrorReason, zIn };
export type { In };
